$(document).ready(function () {
  $(function () {
    var galleryThumbs = new Swiper(".gallery-thumbs", {
      centeredSlides: true,
      centeredSlidesBounds: true,
      spaceBetween: 10,
      slidesPerView: 2,
      rtl: true,
      direction: "horizontal",
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      breakpoints: {
        375: {
          slidesPerView: 2,
        },
        425: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          direction: "vertical",
          slidesPerView: 3,
        }
      }
    });

    var galleryTop = new Swiper(".gallery-top", {
      direction: "horizontal",
      spaceBetween: 10,
      rtl: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      a11y: {
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
      },
      keyboard: {
        enabled: true,
      },
      thumbs: {
        swiper: galleryThumbs
      },
      pagination: {
        el: '.swiper-pagination-thumb',
        clickable: true,
      },
      breakpoints: {
        425: {
          direction: "horizontal",
        },

      }
    });

    $(window).on('resize', function () {
      galleryThumbs.update();
      galleryTop.update();
    });

    galleryTop.on("slideChangeTransitionStart", function () {
      galleryThumbs.slideTo(galleryTop.activeIndex);
    });

    galleryThumbs.on("transitionStart", function () {
      galleryTop.slideTo(galleryThumbs.activeIndex);
    });

    $('.gallery-thumbs .swiper-slide').on('click', function () {
      var index = $(this).index();
      galleryTop.slideTo(index);
    });
  });
});
